import React, { useState } from "react";
import { Layout, Typography, Row, Col, Card, Tag, Grid } from "antd";
import { Link } from "react-router-dom";
import IcastHeader from "../Layouts/IcastHeader";
import Footer from "../Layouts/IcastFooter";
import "../Styles/ExpoStyles.css";

// ✅ Your logos (keep only once)
import img from "../Assets/BARIA.jpg";
import img1 from "../Assets/HEC.jpg";
import img2 from "../Assets/IEEE.jpg";
import img3 from "../Assets/ISNET.jpg";
import img4 from "../Assets/NCGSA.jpg";
import img5 from "../Assets/NPU.jpg";
import img6 from "../Assets/PSF.jpg";
import img7 from "../Assets/SGAC.jpg";
import img8 from "../Assets/Icesco.jpg";
import img9 from "../Assets/Mino-Space.png";
import img10 from "../Assets/apsco.png";
import img11 from "../Assets/tsa.png";
import img12 from "../Assets/azercosmos-logo-0.png";
import img13 from "../Assets/keo-scientific-1200x630-1.jpg";
import img14 from "../Assets/uraan.jpg";
import img15 from "../Assets/iran.png";

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;
const { useBreakpoint } = Grid;

/** ✅ Small component: 6 lines + Read more / Read less */
const PartnerDetail = ({ text }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <Text className={`partner-detail ${expanded ? "expanded" : ""}`}>
        {text}
      </Text>

      <span
        className="read-more-link"
        onClick={(e) => {
          e.stopPropagation(); // ✅ prevents card click
          setExpanded((prev) => !prev);
        }}
      >
        {expanded ? "Read less" : "Read more"}
      </span>
    </>
  );
};

const PartnersSponsors = () => {
  const screens = useBreakpoint();

  const titleFontSize = screens.xl
    ? 48
    : screens.lg
    ? 46
    : screens.md
    ? 40
    : 32;
  const paragraphFontSize = screens.xl ? 16 : screens.lg ? 16 : 15;

  // ✅ Edit details + URLs
  const partners = [
    {
      id: 1,
      name: "HEC",
      type: "Partner",
      detail:
        "The Higher Education Commission (HEC) of Pakistan is an autonomous organization responsible for regulating, developing, and promoting higher education in the country. It formulates national policies, ensures quality assurance, accredits degree-awarding institutions, and provides funding and scholarships to support research and innovation. HEC plays a vital role in strengthening Pakistan’s universities, fostering academic excellence, and advancing a knowledge-based economy to enhance the nation’s global competitiveness.",
      logo: img1,
      url: "https://hec.gov.pk",
    },
    {
      id: 2,
      name: "NCGSA",
      type: "Host / Sponsor",
      detail:
        "The National Center of GIS & Space Applications (NCGSA) is a national-level initiative in Pakistan established under the Higher Education Commission (HEC) Pakistan, to advance research, development, and human resource capacity in the domains of Geographic Information Science (GIS) and space applications. The center coordinates a consortium of seven research labs across partner higher education institutions and focuses on key areas including remote sensing & GIS, small satellite technology, positioning, navigation & timing (PNT), astronomy & astrophysics, space outreach & education, and advanced systems.",
      logo: img4,
      url: "https://ncgsa.org.pk",
    },
    {
      id: 3,
      name: "APSCO",
      type: "International Partner",
      detail:
        "Asia-Pacific Space Cooperation Organization (APSCO) is an inter-governmental organization headquartered in Beijing, China, formed to promote cooperation among its Member States in the peaceful applications of space science and technology. The organization facilitates joint development of space technology, space science research, training programs, and the sharing of achievements between countries in the Asia-Pacific region.",
      logo: img10,
      url: "http://www.apsco.int/",
    },
    {
      id: 4,
      name: "ISNET",
      type: "Partner",
      detail:
        "The Inter-Islamic Network on Space Sciences & Technology (ISNET), established in 1987 under the auspices of the Standing Committee on Scientific and Technological Cooperation (COMSTECH), is an inter-state, non-profit organization headquartered at Pakistan Space & Upper Atmosphere Research Commission (SUPARCO), Pakistan. It brings together 17 member states of the Organization of Islamic Cooperation (OIC) to promote space science, technology, and their peaceful applications within the Islamic world.",
      logo: img3,
      url: "https://isnet.org.pk/",
    },
    {
      id: 5,
      name: "ICESCO",
      type: "International Partner",
      detail:
        "The Islamic World Educational, Scientific and Cultural Organization (ICESCO) is an inter-governmental organization operating under the umbrella of the Organization of Islamic Cooperation (OIC), dedicated to the fields of education, science, culture, and communication across the Islamic world. Headquartered in Rabat, Morocco, it serves 53 member states across four regions (Africa, Arab region, Asia, and Latin America) and functions officially in Arabic, English, and French. Its mission is to strengthen cooperation among member states in its core domains, promote cultural identity and heritage, advance scientific research and innovation, and foster dialogue among civilizations.",
      logo: img8,
      url: "https://icesco.org/en/",
    },
    {
      id: 6,
      name: "BRAIA",
      type: "Partner",
      detail:
        "Belt and Road Aerospace Innovation Alliance (BRAIA) was initiated by Northwestern Polytechnical University (NPU) and the Chinese Society of Astronautics (CSA). BRAIA is an international organization, with NPU serving as its Permanent Secretariat, and is formed by universities, research institutes, academic organizations, and enterprises mainly in the field of aerospace. Officially launched in March 2025, BRAIA has 84 members from 25 countries.The mission of BRAIA is to enhance international cooperation on aerospace technology and applications. Its focus is to promote substantial cooperation among BRAIA members in talent cultivation, scientific research, technology development, and applications, thereby advancing innovation and collaboration in the global aerospace sector.",
      logo: img,
      url: "https://braia.nwpu.edu.cn/english/Home.htm",
    },
    {
      id: 7,
      name: "MinoSpace",
      type: "Industry Partner",
      detail:
        "Beijing Minospace Technology Co., Ltd. was established in August 2017. The company focuses on the R&D and manufacturing of complete satellites and ground station products, providing end-to-end, integrated satellite–ground solutions for customers, including mission analysis, design, manufacturing, testing, launch, and TT&C services.As a national-level “Little Giant” specialized and innovative enterprise, a certified high-tech enterprise, and a recognized unicorn in the commercial space sector, Minospace owns proprietary satellite platforms and core subsystems, mastering nearly 40 key satellite technologies and holding over 300 registered patents. To date, the company has successfully developed and launched 28 satellites ranging from 10 to 1000 kg, covering diverse application fields such as narrowband low-power communications, broadband satellite internet, medium- and high-resolution optical remote sensing, hyperspectral infrared remote sensing, high-resolution synthetic aperture radar (SAR), as well as scientific and technological demonstration missions.",
      logo: img9,
      url: "https://www.minospace.cn/",
    },
    {
      id: 8,
      name: "Uraan Pakistan",
      type: "Partner",
      detail:
        "URAAN Pakistan is a flagship national initiative launched under the 5Es National Economic Transformation Plan to drive Pakistan toward sustainable progress and prosperity. The program focuses on five strategic pillars—Exports, E-Pakistan, Energy, Environment (Climate Change), and Equity & Empowerment—which together form the foundation for holistic national growth. By integrating innovation, technology, and inclusive development, URAAN Pakistan aims to position the country on the path to becoming a trillion-dollar economy by 2035. It brings together policymakers, researchers, industry leaders, and youth to collaboratively design and implement transformative solutions addressing Pakistan’s most pressing challenges in trade, energy, digitalization, and social equity.",
      logo: img14,
      url: "https://uraanpakistan.pk/",
    },
    {
      id: 9,
      name: "PSF",
      type: "Sponsor",
      detail:
        "The Pakistan Science Foundation (PSF) is the leading national organization dedicated to promoting and funding scientific research and innovation across Pakistan. Operating under the Ministry of Science & Technology, PSF supports research projects in diverse fields, provides grants to universities and R&D institutions, and works to strengthen the country’s science and technology infrastructure. In addition to research funding, PSF plays a vital role in fostering scientific awareness among youth through science fairs, clubs, and educational outreach programs. Through its initiatives, the Foundation aims to advance Pakistan’s scientific capacity, encourage innovation, and contribute to national socio-economic development.",
      logo: img6,
      url: "https://psf.gov.pk",
    },
    {
      id: 10,
      name: "IEEE",
      type: "Technical Partner",
      detail:
        "The Institute of Electrical and Electronics Engineers (IEEE) is the world’s largest technical professional organization, dedicated to advancing technology for the benefit of humanity. It serves a global community of engineers, scientists, and allied professionals through publications, conferences, standards development, education, and professional activities. IEEE also plays a leading role in setting industry standards in fields such as electronics, communications, computing, and power & energy, fostering innovation and technological excellence worldwide.",
      logo: img2,
      url: "https://www.ieee.org",
    },
    {
      id: 11,
      name: "TSA",
      type: "Partner",
      detail:
        "Turkish Space Agency (TUA) is Türkiye’s national space authority, established by Presidential Decree No. 23 in December 2018. Its mission is to serve as the face of Türkiye in space, coordinating national and international efforts in space and aerospace technologies, defining strategic plans for medium- and long-term goals, and ensuring the protection and promotion of Türkiye’s interests in outer space. TUA supports the development of the country’s space ecosystem, including satellite manufacturing, launch capabilities, scientific research, and space-based services, and leads initiatives for technological independence and enhanced international cooperation in the “New Space Age.”",
      logo: img11,
      url: "https://tua.gov.tr/en",
    },
    {
      id: 12,
      name: "Azercosmos",
      type: "International Partner",
      detail:
        "Azercosmos is the Space Agency of the Republic of Azerbaijan, established in 2010 as the region’s first satellite operator and currently fully government-owned. It provides telecommunications and Earth-observation services globally via its satellite fleet, including the telecom satellites Azerspace-1 and Azerspace-2, and the optical observation satellite Azersky. With its mission, Azercosmos aims to advance Azerbaijan’s space ecosystem by delivering high-quality satellite services, engaging in research and development, nurturing talent, and facilitating international collaborations in the space industry.",
      logo: img12,
      url: "https://azercosmos.az/en",
    },
    {
      id: 13,
      name: "SGAC",
      type: "International Partner",
      detail:
        "Space Generation Advisory Council (SGAC) is a global non-governmental, non-profit network dedicated to representing university students and young space professionals (ages 18–35) to the United Nations Committee on the Peaceful Uses of Outer Space (UN COPUOS), space agencies, industry, and academia. Founded in 1999 and headquartered in Vienna, Austria, SGAC has grown to include tens of thousands of members across more than 150 countries. Its mission is to channel the creativity, energy, and perspectives of the next generation toward the peaceful, inclusive, and sustainable use of outer space. SGAC organizes global and regional events—such as the Space Generation Congress—and runs working groups and project teams focusing on space law, new space technologies, sustainability, and youth engagement, thereby empowering young leaders in the space sector.",
      logo: img7,
      url: "https://spacegeneration.org",
    },

    {
      id: 14,
      name: "NPU",
      type: "Academic Partner",
      detail:
        "Northwestern Polytechnical University (NPU) is a major public research university based in Xi’an, Shaanxi Province, China, affiliated with the Ministry of Industry & Information Technology of the People’s Republic of China (PRC). It is distinguished by its strong focus on aeronautics, astronautics, and marine engineering, while also offering a wide range of other disciplines. NPU has been recognized as a “national key university”, participates in major national programs such as Project 211 and Project 985, and aims to build first-class disciplines globally through excellence in education, research, and innovation.",
      logo: img5,
      url: "https://en.nwpu.edu.cn/",
    },
    {
      id: 15,
      name: "KEO Scientific",
      type: "Industry Partner",
      detail:
        "Keo Scientific Ltd., based in Calgary, Canada, designs and builds highly sensitive scientific instrumentation for geospace and upper-atmosphere research. Their product range includes imagers, Fabry–Perot interferometers, spectrographs, photometers, and radio instruments, used in applications such as auroral studies, mesosphere/ionosphere monitoring, and atmospheric imaging worldwide. With over two decades of experience, Keo Scientific’s equipment is field-proven in extreme environments ranging from the Arctic to the equator, and is tailored for both research institutions and operational deployments.",
      logo: img13,
      url: "https://www.keoscientific.com",
    },
    {
      id: 16,
      name: "IRANIAN SPACE AGENCY",
      type: "International Partner",
      detail:
        "The Iranian Space Agency (ISA) is responsible for all peaceful activities undertaken by relevant authorities in the area of space science and technology. The agency serves as the focal point and representative of the Government of the Islamic Republic of Iran in all international space-related organizations and forums. The main duties of the Iranian Space Agency include designing and manufacturing satellites, conducting research and operational satellite missions, and developing and expanding space applications across the country in support of national scientific and technological advancement..",
      logo: img15,
      url: "https://www.un-spider.org/network/regional-support-offices/iranian-space-agency-isa",
    },
  ];

  const openWebsite = (url) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <IcastHeader />
      <Layout style={{ background: "#fff" }}>
        <Content>
          {/* Page Header */}
          <Title
            style={{
              textAlign: "left",
              padding: screens.xs ? "18px 18px" : "20px 40px",
              fontFamily: "Inter, sans-serif",
              fontWeight: 800,
              fontSize: titleFontSize,
              backgroundColor: "#EEF0F2",
              margin: 0,
            }}
          >
            Partners & Sponsors
          </Title>

          {/* Intro */}
          <div
            style={{ padding: screens.xs ? "8px 18px 18px" : "10px 40px 20px" }}
          >
            <Paragraph
              style={{
                fontSize: paragraphFontSize,
                color: "black",
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                marginBottom: 18,
              }}
            >
              ICAST 2025 is supported by a strong network of partners and
              sponsors from academia, industry, government, and international
              organizations. Click any card to visit the partner website.
            </Paragraph>

            {/* Cards Grid */}
            <Row gutter={[16, 16]}>
              {partners.map((p) => (
                <Col key={p.id} xs={24} sm={12} md={8} lg={6}>
                  <Card
                    hoverable
                    onClick={() => openWebsite(p.url)}
                    className="partner-card"
                    cover={
                      <div className="partner-logo-wrap">
                        <img
                          src={p.logo}
                          alt={p.name}
                          className="partner-logo-img"
                        />
                      </div>
                    }
                  >
                    <div className="partner-card-header">
                      <Title level={4} style={{ margin: 0 }}>
                        {p.name}
                      </Title>
                      <Tag>{p.type}</Tag>
                    </div>

                    <PartnerDetail text={p.detail} />

                    <Text className="partner-link">Open website →</Text>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Content>
      </Layout>
      <Footer />
    </>
  );
};

export default PartnersSponsors;
